import { SparkleIcon } from "@phosphor-icons/react";

export interface ChipTagProps {
    "data-testid"?: string;
    label: string;
    onClick: () => void;
}

export const ChipTag = (props: ChipTagProps) => {
    return (
        <button
            type="button"
            data-testid={props["data-testid"]}
            onClick={props.onClick}
            className="border border-p6-grey-light rounded-pill px-s py-xxs flex flex-row items-center gap-xs cursor-pointer bg-white hover:bg-p6-grey-lightest/40"
        >
            <SparkleIcon
                size={20}
                className="text-p6-grey-dark shrink-0"
            />
            <span className="text-l text-p6-grey-dark">{props.label}</span>
        </button>
    );
};
